import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {useApp} from "hooks/StateHooks"
import React from "react"
import Modal from "./Modal"
import Trans from './Trans'

type DealerInformationModalProps = {
  hideModal: () => void
}

class DealerInformationModal extends React.Component<DealerInformationModalProps> {
  private app = useApp()

  render() {
    const header = (
      <div className="px-3 py-2 text-gray-700 font-semibold flex flex-row justify-between items-center">
        <span><Icon icon="align-left"/> <Trans>Händler-Info</Trans></span>
        <button onClick={this.props.hideModal} className={"flex border-0 font-semibold text-lg rounded text-gray-600 hover:text-gray-700 px-2 py-1"} type="button">
          <Icon icon="times"/>
        </button>
      </div>
    )
    const footer = (
      <div className="flex flex-row justify-end py-2 px-3">
        <button onClick={() => this.props.hideModal()} className={"border-0 rounded text-gray-500 hover:bg-gray-200 px-2 py-1"} type="button">
          <Trans>Schließen</Trans>
        </button>
      </div>
    )
    const body = (
      <div className={"text-gray-700 w-full h-full"}>
        <pre className="font-sans h-full w-full p-4 whitespace-pre-wrap">
          {this.app.settings.news || <Trans>'Keine Händler-Info verfügbar'</Trans>}
        </pre>
      </div>
    )
    return (<Modal header={header} footer={footer} body={body}/>)
  }
}

export default DealerInformationModal
